import React from 'react';
import { Menu, Icon, Dropdown, Popup } from 'semantic-ui-react';
import { NavLink as Link, useNavigate  } from "react-router-dom";

import authActions from "actions/auth/auth";
import './index.scss';
import { connect } from 'react-redux';
import { DYLAvatar, USER_PERMISSIONS } from 'dyl-components';
import appActions from 'actions/app/app';
import { useDispatch } from "react-redux";
import basePath from 'actions/basePath';
import RestrictedView from 'shared/RestrictedView';
import role from 'actions/role';
import subscription from 'actions/subscription';

const TopNavigation = ({isSidebarOpen, setSidebarOpen, onLogOut, name, email, user_id, profilePicture, savedSettingsRoute }) => {
const navigate = useNavigate();
const dispatch = useDispatch();

return (
    <Menu fixed='top' borderless className={`SettingsPage__TopNavigation SettingsPage__TopNavigation${isSidebarOpen ? '--squished' : '--full'}`}>
        <Menu.Item position='left'>
            <Icon name={`angle ${isSidebarOpen ? 'left' : 'right'}`} circular link onClick={setSidebarOpen} />
        </Menu.Item>
        <Menu.Item>
            <Dropdown
                inline
                style={{ color: "#303f9f" }}
                text={
                    <Popup
                        trigger={<Icon
                            className="fas fa-question-circle"
                            size="large"
                        />}
                        content='Support'
                        position='left center'
                        inverted
                    />
                }
                pointing='top right'
            >
                <Dropdown.Menu>
                    {/* <Dropdown.Item
                        content='Help'
                        href='https://dyl-cloud.atlassian.net/servicedesk/customer/portals'
                        target='_blank'
                    /> */}
                    <Dropdown.Item
                        content='Support'
                        href='https://dyl.com/support'
                        target='_blank'
                    />
                </Dropdown.Menu>
            </Dropdown>
        </Menu.Item>
        <Menu.Item>
            <Dropdown
                inline
                style={{ color: "#303f9f" }}
                text={
                    <DYLAvatar name={name} email={email} picture={profilePicture} position='left center'/>
                }
                pointing='top right'

            >
                <Dropdown.Menu>
                    <Dropdown.Item
                        content="Profile"
                        as={Link}
                        to={`/settings/users/${user_id}/general`}
                    />
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.BILLING_VIEW}>
                    <Dropdown.Item 
                        content="Billing" 
                        as={Link}
                        to={`/settings/billing/overview`}
                    />
                    </RestrictedView>
                    <Dropdown.Item
                        content="Logout"
                        onClick={onLogOut}
                    />
                </Dropdown.Menu>
            </Dropdown>
        </Menu.Item>
        <Menu.Item>
            <Popup
                trigger={<Icon
                    className="x"
                    size="large"
                    style={{ color: "#303f9f" }}
                    onClick={() => {
                        navigate(savedSettingsRoute);
                        dispatch(appActions.onSaveSettingsRoute(""));
                    }} 
                />}
                content='Close Settings'
                position='left center'
                inverted
            />
        </Menu.Item>
    </Menu>
)};

const mapStateToProps = state => ({
    name: state.auth.name,
    email: state.users.userProfile.email,
    user_id: state.auth.user_id,
    savedSettingsRoute : state.app.savedSettingsRoute,
    profilePicture: state.user.logged_in_user_image ? state.user.logged_in_user_image  : '',
})

const mapDispatchToProps = dispatch => {
    return {
        onLogOut: () => {
            dispatch(authActions.logout()).then(() => {
                if (window.location.hostname.includes("sales")) {
                    window.location.href = `${basePath.USER_HOST}/login`;
                }
            });
            dispatch(role.resetRole("RESET_ROLE"));
            dispatch(subscription.resetProduct("RESET_PRODUCT"));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopNavigation);
